package com.eladfinish.bible.contest.screens.search.ui.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.eladfinish.bible.contest.data.common.DocumentTextType
import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsAction
import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsEffect
import com.eladfinish.bible.contest.features.copyOptions.CopyOptionsStore
import com.eladfinish.bible.contest.features.copyOptions.ui.CopyOptionsDialog
import com.eladfinish.bible.contest.screens.search.mvi.SearchAction
import com.eladfinish.bible.contest.screens.search.mvi.SearchState
import dev.icerock.moko.resources.compose.localized
import kotlinx.coroutines.flow.collectLatest
import org.koin.compose.viewmodel.koinViewModel

@Composable
internal fun CopyOptionsDialogComponent(
    dialogState: SearchState.DialogState.CopyOptionsDialog,
    onAction: (SearchAction) -> Unit,
) {
    val copyOptionsStore: CopyOptionsStore = koinViewModel()

    LaunchedEffect(
        dialogState.config,
        dialogState.input,
    ) {
        copyOptionsStore.dispatch(
            CopyOptionsAction.Init(
                operation = dialogState.operation,
                config = dialogState.config,
                input = dialogState.input,
                bookAndChapterForExport = "",
                shouldAddParenthesisOnOtiotPasuk = false,
                documentTextType = DocumentTextType.TXT,
            ),
        )
    }

    LaunchedEffect(copyOptionsStore) {
        copyOptionsStore.observeSideEffect().collectLatest { effect ->
            when (effect) {
                CopyOptionsEffect.CloseDialog -> {
                    onAction(
                        SearchAction.HideDialog,
                    )
                }

                is CopyOptionsEffect.SaveFile -> {
                    onAction(
                        SearchAction.SaveFile(
                            content = effect.content,
                        ),
                    )

                    onAction(
                        SearchAction.HideDialog,
                    )
                }
            }
        }
    }

    CopyOptionsDialog(
        store = copyOptionsStore,
        title = dialogState.title.localized(),
        onDismiss = {
            onAction(
                SearchAction.HideDialog,
            )
        },
    )
}
